import {
  ICommonFloatInputRenderParams,
  ICommonFloatInputRenderParamsResult,
  ILimit,
} from '../../types';
import { ORDER_STATUS_VALUE } from '@shared/types/enums/order-status.enum';
import { generateDecimalRegexp } from '@shared/constants';
import {
  DEFAULT_DISPLAY_DECIMAL,
  MAX_INT_FOR_ORDER_QUANTITY,
  MIN_INT_FOR_ORDER_QUANTITY,
} from '@config/global-constants';

export const orderCountLimit: ILimit<number> = {
  minimum: 0,
  maximum: 9999.99,
};

export const receivedOrderCountLimit: ILimit<number> = {
  minimum: -9999.99,
  maximum: 9999.99,
};

export const unitCountLimit: ILimit<number> = {
  minimum: 0,
  maximum: 9999999.99,
};

export const hiddenVendorStatus: ORDER_STATUS_VALUE[] = [
  ORDER_STATUS_VALUE.Pending,
  ORDER_STATUS_VALUE.Canceled,
  ORDER_STATUS_VALUE.Completed,
  ORDER_STATUS_VALUE.Rejected,
];

// please insure the min or max not as 0, when use this function.
// when use 0, should set overrideMin or overrideMax as false.
export const getCommonFloatInputRenderParams = ({
  precision,
  placeholder = DEFAULT_DISPLAY_DECIMAL,
  min = MIN_INT_FOR_ORDER_QUANTITY,
  max = MAX_INT_FOR_ORDER_QUANTITY,
  acceptableInputRegex,
  usePreferenceDecimalPrecision = {
    overrideMin: true,
    overrideMax: true,
  },
}: ICommonFloatInputRenderParams): ICommonFloatInputRenderParamsResult => {
  const allowNegativeInputByBoundary = min < 0 || max < 0;
  const resolvedAcceptableInputRegex = acceptableInputRegex
    ? acceptableInputRegex
    : generateDecimalRegexp(precision, !allowNegativeInputByBoundary);

  return {
    placeholder,
    min,
    max,
    usePreferenceDecimalPrecision,
    disableKeyUpFinishEditing: true,
    acceptableInputRegex: resolvedAcceptableInputRegex,
  };
};
